<template>
  <section class="section-shaped my-0 py-2">
  	<div class="container">
  		<v-wait for="titulo.ficha.load" transition="fade" :duration="750"> 
  			<template slot="waiting">
  				<div class="col">
  					<div class="ph-col-5 mt-3 mb-5"></div>
  					<div class="ph-container">
  						<div class="ph-col-8 mb-2"></div><div class="ph-col-1 empty mb-2"></div><div class="ph-col-3 mb-2"></div>
  						<div class="ph-col-8 mb-2"></div><div class="ph-col-1 empty mb-2"></div><div class="ph-col-3 mb-2"></div>
  					</div>
  				</div>
  			</template>
  		<div class="col" v-if="movie.diretor || movie.elenco || movie.dublagem">
  			<h3 class="display-3">Ficha Tecnica</h3>
  			<div class="ficha-row" v-if="movie.diretor">
  				<p>Diretor</p>
  				<p>{{movie.diretor}}</p>
  			</div>
  			<div class="ficha-row" v-if="movie.elenco">
  				<p>Elenco</p>
  				<p class="elenco">{{movie.elenco}}</p>
  			</div>
  			<div class="ficha-row" v-if="movie.dublagem">
  				<p>Dublagem</p>
  				<p>{{movie.dublagem}}</p>
  			</div>
  		</div>
  		</v-wait>
  	</div>
  </section>
</template>
<script>
export default {
  name: 'movieFichaTecnica',
  computed: {
    movie() {
      return this.$store.state.catalog.movie;
    }
  }
};
</script>
<style scoped>
	.elenco {
		white-space: pre-wrap;
	}
	.ficha-row {
		width: 100%;
		display: table;
		border-bottom: 1.5px dotted #dadada;
	}
	.ficha-row > p {
		width: 50%;
		float: left;
		margin-top: 15px;
	}
	.ficha-row p:first-child {
		font-weight: 700;
	}
	.ficha-row p:last-child {
		text-align: right;
	}
	.ficha-row:last-child {
		border-bottom: none;
	}
	@media screen and (max-width: 992px) {

		.ficha-row > p {
			width: 100%;
			float: none;
			margin-top: 15px;
		}
		.ficha-row p:last-child {
			text-align: left;
		}

	}
</style>
